import firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';
const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG!);
firebase.initializeApp(config);
export default firebase;
